import * as auditLogHelper from 'helpers/audit-log-helper';
import * as logger from 'logger';
import { AuditLogType } from 'types/audit-log-type';
import { CLEAR_LIST } from './actions';
import { Middleware, MiddlewareAPI } from 'redux';
import { usernameSelector } from 'pages/user-profile/selectors';
import { AppState } from 'pages/app/state';
import { removeCompletedItems } from 'services/item-service';
import { currentOperationSelector } from 'components/menu/selectors';
import { ListOperationItemsAction } from 'components/operation-grid/actions';
import { connectionSelector } from 'components/connection-status/selectors';

const ClearListMiddleware: Middleware = store => next => async action => {
  try {
    switch (action.type) {
      case CLEAR_LIST:
        await clearList(store);
        break;

      default:
        next(JSON.parse(JSON.stringify(action)));
        break;
    }
  }
  catch (e) {
    const error = e as Error;
    logger.error(error, 'ClearListMiddleware');
  }
};

async function clearList(store: MiddlewareAPI): Promise<void> {
  try {
    const state = store.getState() as AppState;
    const currentOperation = currentOperationSelector(state).nmvsOperation;

    await removeCompletedItems(currentOperation);

    store.dispatch(new ListOperationItemsAction);

    auditLogHelper.writeAuditLog(store, AuditLogType.ClearList, 
      'ClearList', '', `${usernameSelector(state)} cleared the list.`,  connectionSelector(state));
  } 

  catch (error) {
    throw new Error(error);
  }
}

export default ClearListMiddleware;


// WEBPACK FOOTER //
// ./src/components/clear-list/middleware.ts